export const DEFAULT_WEBCAM_SIMULCAST_ENCODINGS = [
  {
    scaleResolutionDownBy: 4, // 320x180 0.15mbps 12fps by default
    maxBitrate: 150000,
    maxFramerate: 12,
  },
  {
    scaleResolutionDownBy: 2, // 640x360 0.35mbps 18fps by default
    maxBitrate: 350000,
    maxFramerate: 18,
  },
  {
    scaleResolutionDownBy: 1, // 1280x720 0.9mbps 24fps by default
    maxBitrate: 900000,
    maxFramerate: 24,
  },
];

export const DEFAULT_SCREEN_MEDIA_SIMULCAST_ENCODINGS = [
  {
    maxBitrate: 1000000, // 1920x1080 1mbps 30fps by default
    dtx: true,
  },
];

export const DEFAULT_AUDIO_ENCODINGS = [{ maxBitrate: 40_000, dtx: true }];
